module.exports = __webpack_public_path__ + "img/confetti.7002164c.png";